module.exports = __webpack_public_path__ + "static/media/consultationPppEn.0ad75b43.jpg";